<style lang="scss" scoped>
@use 'sass:color';
@use '../../../palette.scss' as *;

.content-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    margin: 0 10px 10px;
    border-top: 1px solid $theme-light-grey;
    padding: 8px 5px;

    .fa-plus {
        margin-right: 4px;
    }
}

.personnel-body {
    display: flex;
    flex-direction: column;

    .add-container {
        display: flex;
        flex-flow: column;
        padding: 10px;

        .control-row {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin: 5px 0;

            button {
                min-width: 150px;
            }

            .dropdown-container {
                min-width: 180px;
            }

            .fa-plus {
                margin-right: 4px;
            }
        }
    }

    .users-container {
        display: flex;
        flex-flow: column;
        margin: 0 15px;
        width: 100%;

        .user-block {
            padding: 10px 0;
            margin-right: 20px;

            & > span {
                font-weight: bold;
            }

            .user-row {
                display: flex;
                align-items: center;
                text-indent: -5px;
                padding: 0 30px 0 8px;
                word-break: break-word;
                position: relative;
                width: 100%;

                &:hover {
                    .delete-btn-ctn {
                        opacity: 1;
                    }
                }

                .delete-btn-ctn {
                    transition: opacity 0.25s;
                    position: absolute;
                    opacity: 0;
                    right: 0;

                    button {
                        background-color: transparent;
                        color: $theme-red;
                        font-size: 1.7em;
                        border: none;
                        outline: none;

                        i {
                            border-radius: 50%;

                            &:hover {
                                background-color: color.adjust(
                                    $theme-red,
                                    $alpha: -0.85
                                );
                                color: color.adjust(
                                    $theme-red,
                                    $lightness: -5%
                                );
                            }

                            &:active {
                                transform: scale(0.97);
                            }
                        }
                    }
                }
            }
        }
    }

    @media (min-width: 662px) {
        flex-flow: row nowrap;

        .add-container {
            padding: 0 10px 0 0;
            margin: 10px 0;
            width: 50%;
            border-right: 1px solid $theme-light-grey;
        }

        .users-container {
            width: 50%;

            .user-block {
                margin: 0;
            }
        }
    }
}
</style>

<template>
    <div class="personnel-body">
        <div class="add-container">
            <div class="control-row">
                <DropdownMenu
                    :options="userOptions"
                    :maxHeight="'200px'"
                    outline
                    @change="setSelectedAddUser"
                    :value="selectedAddUser.user_id"
                ></DropdownMenu>
            </div>
            <div class="control-row">
                <Button
                    small
                    @click="addNotifiedUser"
                    :disabled="!selectedUserValidNotifiedUser"
                >
                    <i class="fa fa-plus"></i> {{ $t('notifieduser') }}
                </Button>
            </div>
            <div class="control-row">
                <Button
                    small
                    @click="addAuthorizedUser"
                    :disabled="!selectedUserValidAuthorized"
                >
                    <i class="fa fa-plus"></i> {{ $t('authorized') }}
                </Button>
            </div>
            <div class="control-row">
                <Button
                    small
                    @click="addViewerUser"
                    :disabled="!selectedUserValidViewerUser"
                >
                    <i class="fa fa-plus"></i> {{ $t('vieweruser') }}
                </Button>
            </div>
        </div>
        <div class="users-container">
            <div class="user-block">
                <span>{{ $t('notifieduser_plural') }}</span>
                <div
                    class="user-row"
                    v-for="notifiedUser in notifiedUsers"
                    :key="notifiedUser.user_id"
                >
                    {{ notifiedUser.name }}
                    <div class="delete-btn-ctn">
                        <button @click="deleteNotifiedUser(notifiedUser)">
                            <i class="far fa-times-circle"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="user-block">
                <span>{{ $t('authorizedUser_plural') }}</span>
                <div class="user-row" v-for="user in users" :key="user.user_id">
                    {{ user.name }}
                    <div class="delete-btn-ctn">
                        <button @click="deleteAuthorizedUser(user)">
                            <i class="far fa-times-circle"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="user-block">
                <span>{{ $t('vieweruser_plural') }}</span>
                <div
                    class="user-row"
                    v-for="viewerUser in viewerUsers"
                    :key="viewerUser.user_id"
                >
                    {{ viewerUser.name }}
                    <div class="delete-btn-ctn">
                        <button @click="deleteViewerUser(viewerUser)">
                            <i class="far fa-times-circle"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="content-header">
        <span>{{ $t('organizationManagement') }}</span>
    </div>
    <div class="personnel-body">
        <div class="add-container">
            <div style="display: flex; gap: 12px; width: 100%">
                <div class="user-block" style="flex: 2">
                    <div class="row">
                        <div class="control-row">
                            <DropdownMenu
                                :options="userOptions"
                                :maxHeight="'200px'"
                                outline
                                @change="setSelectedAddUser"
                                :value="selectedAddUser.user_id"
                            ></DropdownMenu>
                        </div>
                        <div class="control-row">
                            <Button
                                small
                                @click="addManager"
                                :disabled="!selectedAddUserValidManager"
                            >
                                <i class="fa fa-plus"></i> {{ $t('manager') }}
                            </Button>
                        </div>

                        <div class="control-row">
                            <DropdownMenu
                                :options="organizationOptions"
                                :maxHeight="'200px'"
                                outline
                                @change="setSelectedAddOrganization"
                                :value="selectedAddOrganization.id"
                            ></DropdownMenu>
                        </div>
                        <div class="control-row">
                            <Button
                                small
                                @click="addOrganization"
                                :disabled="!selectedAddOrganizationValidManager"
                            >
                                <i class="fa fa-plus"></i>
                                {{ $t('organization') }}
                            </Button>
                        </div>
                    </div>
                    <div class="vertical-separator"></div>
                </div>
            </div>
        </div>
        <div class="users-container">
            <div class="user-block" style="flex: 1">
                <span>{{ $t('manager_plural') }}</span>
                <div
                    class="user-row"
                    v-for="manager in managers"
                    :key="manager.user_id"
                >
                    {{ manager.name }}
                    <div
                        class="delete-btn-ctn"
                        v-if="
                            isUserAdmin ||
                            ((isOrganizationAdmin || isCampaignManager) &&
                                !isOrgManager(manager.user_id))
                        "
                    >
                        <button @click="deleteManager(manager)">
                            <i class="far fa-times-circle"></i>
                        </button>
                    </div>
                </div>

                <div class="user-block">
                    <span>{{ $t('organization_plural') }}</span>
                    <div
                        class="user-row"
                        v-for="organization in campaignOrganizations"
                        :key="organization.organization_id"
                    >
                        {{ organization.name }}
                        <div
                            class="delete-btn-ctn"
                            v-if="
                                isUserAdmin ||
                                ((isOrganizationAdmin || isCampaignManager) &&
                                    !isAdminOrg(organization.organization_id))
                            "
                        >
                            <button
                                @click="
                                    deleteSelectedOrganization(organization)
                                "
                            >
                                <i class="far fa-times-circle"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computedEmitterFactory } from '../../../util/util';
import { getOrganizationUser } from '../../../api/organizations';
import { changeMonitor } from '../../../api/ChangeMonitor.js';
import { mapGetters } from 'vuex';
import { Object } from 'core-js/web';

export default {
    name: 'PersonnelManagement',

    data() {
        return {
            selectedAddUser: { invalid: true },
            selectedAddOrganization: { invalid: true },
            adminOrgIds: [],
        };
    },

    props: {
        campaign: Object,
        managers: {
            type: Object,
            required: true,
        },
        campaignOrganizations: {
            type: Object,
            required: true,
        },
    },

    emits: ['update:managers', 'update:campaignOrganizations'],

    watch: {
        edits(val) {
            this.$store.commit('setEditsOnPage', val);
        },

        usersList(val) {
            if (val.length > 0 && this.selectedAddUser.invalid) {
                this.setSelectedAddUser(val[0].id, val[0].name);
            }
        },
    },

    computed: {
        ...computedEmitterFactory(
            ['users', 'notified_users', 'viewer_users'],
            'campaign',
        ),

        ...mapGetters([
            'isUserAdmin',
            'isOrganizationAdmin',
            'isCampaignManager',
        ]),

        usersList() {
            return this.$store.state.userList;
        },

        alphabeticalUsers() {
            return this.usersList
                .slice()
                .sort(this.$store.getters.intlCompareByName);
        },

        userOptions() {
            const users = this.alphabeticalUsers;
            if (users && users.length > 0) {
                const options = users.reduce((options, user) => {
                    options.push({
                        label: user.name,
                        value: user.id,
                    });
                    return options;
                }, []);
                return options;
            }
            return [];
        },

        organizationOptions() {
            return this.$store.state.organizations.map((org) => ({
                label: org.organization_name,
                value: Number(org.id),
            }));
        },

        selectedAddUserValidManager() {
            if (this.selectedAddUser) {
                // Check to see if this user is already a manager
                if (this.managers) {
                    for (const manager of this.managers) {
                        if (this.selectedAddUser.user_id === manager.user_id) {
                            return false;
                        }
                    }
                }

                return true;
            }
            return false;
        },

        selectedUserValidNotifiedUser() {
            if (this.selectedAddUser) {
                // Check to see if this user is already a Notified User
                if (this.notifiedUsers) {
                    for (const notifiedUser of this.notifiedUsers) {
                        if (
                            this.selectedAddUser.user_id ===
                            notifiedUser.user_id
                        ) {
                            return false;
                        }
                    }
                }

                return true;
            }
            return false;
        },

        selectedUserValidAuthorized() {
            if (this.selectedAddUser) {
                if (this.users) {
                    for (const user of this.users) {
                        if (this.selectedAddUser.user_id === user.user_id) {
                            return false;
                        }
                    }
                }

                return true;
            }
            return false;
        },

        selectedUserValidViewerUser() {
            if (this.selectedAddUser) {
                // Check to see if this user is already a Viewer User
                if (this.viewerUsers) {
                    for (const viewerUser of this.viewerUsers) {
                        if (
                            this.selectedAddUser.user_id === viewerUser.user_id
                        ) {
                            return false;
                        }
                    }
                }
                // check to ensure if this user is not an admin
                for (const user of this.alphabeticalUsers) {
                    if (
                        this.selectedAddUser.user_id === user.id &&
                        user.role === 'server_admin'
                    ) {
                        return false;
                    }
                }

                return true;
            }
            return false;
        },

        selectedAddOrganizationValidManager() {
            if (this.selectedAddOrganization) {
                // Check to see if this organization is already added
                if (this.campaignOrganizations) {
                    for (const organization of this.campaignOrganizations) {
                        if (
                            this.selectedAddOrganization.id ===
                            organization.organization_id
                        ) {
                            return false;
                        }
                    }
                }

                return true;
            }
            return false;
        },
    },

    created() {
        this.edits = false;
        changeMonitor.addNotifiedUser(this.handleChanges);
    },

    beforeDestroy() {
        changeMonitor.removeNotifiedUser(this.handleChanges);
    },

    async mounted() {
        const orgUser = await getOrganizationUser(
            this.$store.state.currentUser.id,
        );
        if (orgUser.payload) {
            this.adminOrgIds.push(parseInt(orgUser.payload.organization_id));
        }
    },

    methods: {
        handleChanges(change) {
            if (change.changeType === 'USER') {
                const updatedUsers = this.usersList.slice();
                let found = false;
                // See if we already have this user
                for (let i = 0; i < updatedUsers.length; i++) {
                    if (updatedUsers[i].id === change.data.id) {
                        found = true;
                        // We do and we shouldn't, get rid of it
                        if (change.data.deleted) {
                            updatedUsers.splice(i, 1);
                        }
                        break;
                    }
                }
                // We're not deleting and the user doesn't already exist
                if (!found && !change.data.deleted) {
                    updatedUsers.push({ ...change.data });
                }
                // Update the store with what we have
                this.$store.commit('setUserList', updatedUsers);
            }
        },

        setSelectedAddUser(userId, username) {
            this.selectedAddUser = {
                user_id: userId,
                name: username,
            };
        },

        setSelectedAddOrganization(id, name) {
            this.selectedAddOrganization = {
                id: id,
                name: name,
            };
        },

        addManager() {
            // a parent call assiociated with PersonnelManagement element in CampaignEdit
            // required as the save action and data objects are in the parent and reactive
            // properties can't update into the parent from the child
            this.$emit('update:managers', this.selectedAddUser);
        },

        addOrganization() {
            // a parent call assiociated with PersonnelManagement element in CampaignEdit
            // required as the save action and data objects are in the parent and reactive
            // properties can't update into the parent from the child
            this.$emit(
                'update:campaignOrganizations',
                this.selectedAddOrganization,
            );
        },

        deleteManager(manager) {
            // a parent call assiociated with PersonnelManagement element in CampaignEdit
            // required as the save action and data objects are in the parent and reactive
            // properties can't update into the parent from the child
            this.$emit('delete:manager', manager);
        },

        deleteSelectedOrganization(organization) {
            // a parent call assiociated with PersonnelManagement element in CampaignEdit
            // required as the save action and data objects are in the parent and reactive
            // properties can't update into the parent from the child
            this.$emit('delete:campaignOrganization', organization);
        },

        addNotifiedUser() {
            if (this.selectedUserValidNotifiedUser) {
                if (this.notifiedUsers) {
                    this.notifiedUsers = [
                        ...this.notifiedUsers,
                        this.selectedAddUser,
                    ];
                } else {
                    this.notifiedUsers = [this.selectedAddUser];
                }
            } else {
                console.error('Cannot add user, id not found in users list');
            }
        },

        addAuthorizedUser() {
            if (this.selectedUserValidAuthorized) {
                if (this.users) {
                    this.users = [...this.users, this.selectedAddUser];
                } else {
                    this.users = [this.selectedAddUser];
                }
            } else {
                console.error('Cannot add user, id not found in users list');
            }
        },

        addViewerUser() {
            if (this.selectedUserValidViewerUser) {
                if (this.viewerUsers) {
                    this.viewerUsers = [
                        ...this.viewerUsers,
                        this.selectedAddUser,
                    ];
                } else {
                    this.viewerUsers = [this.selectedAddUser];
                }
            } else {
                console.error('Cannot add user, id not found in users list');
            }
        },

        deleteNotifiedUser(notifiedUser) {
            if (this.notifiedUsers) {
                this.notifiedUsers = this.notifiedUsers.filter(
                    (w) => w.user_id !== notifiedUser.user_id,
                );
            }
        },

        deleteAuthorizedUser(user) {
            if (this.users) {
                this.users = this.users.filter(
                    (u) => u.user_id !== user.user_id,
                );
            }
        },

        deleteViewerUser(viewerUser) {
            if (this.viewerUsers) {
                this.viewerUsers = this.viewerUsers.filter(
                    (w) => w.user_id !== viewerUser.user_id,
                );
            }
        },

        isOrgManager(id) {
            return this.$store.state.currentUser.id === id;
        },

        isAdminOrg(id) {
            return this.adminOrgIds.includes(id);
        },
    },
};
</script>
